<div class="gridster-nav" *ngIf="!(dashboardDataSvc.edit$ | async)">
  <dx-button icon="preferences" (click)="onEdit()"></dx-button>
</div>

<div class="gridster-settings-nav" *ngIf="dashboardDataSvc.edit$ | async">
  <div>
    <dx-button *ngIf="dashboardDataSvc.configuration.layoutName === 'custom'" icon="add"
      (click)="addEmptyWidget()"></dx-button>
  </div>

  <div class="gridster-layout-buttons">
    <dx-button [text]="'custom' | translateWithFallback" (click)="setLayout({name: 'custom'})"></dx-button>
    <ng-container *ngFor="let layout of defaultLayouts">
      <dx-button [icon]="layout.icon" (click)="setLayout(layout)" class="layout-button"></dx-button>
    </ng-container>
  </div>

  <div>
    <dx-button icon="close" (click)="onEditClose()"></dx-button>
  </div>
</div>

<div class="gridster-container">
  <gridster [options]="dashboardDataSvc.configuration.gridsterOptions" class="gridster-board">
    <ng-template ngFor let-item let-i="index" [ngForOf]="dashboardDataSvc.widgets$ | async">
      <ng-container *ngIf="dashboardDataSvc.fullScreenMode">
        <app-widget-wrapper [item]="item"></app-widget-wrapper>
      </ng-container>
      <gridster-item [item]="item.gridsterWidgetOptions" *ngIf="!dashboardDataSvc.fullScreenMode">
        <app-widget-wrapper [item]="item"></app-widget-wrapper>
      </gridster-item>
    </ng-template>
  </gridster>
</div>